import React from 'react';

import MachineControlIcon from './machine-control.svg?react';

export default function FarmbotMachineControlIcon() {
  return <MachineControlIcon width={18} />;
}
